/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Account_LockedInputs */

const vi_error_shop_account_locked = /** @type {(inputs: Error_Shop_Account_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản khách đang bị khoá.`)
};

/**

* @param {Error_Shop_Account_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_account_locked = /** @type {((inputs?: Error_Shop_Account_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Account_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_account_locked(inputs)
});